import { createApp } from 'vue'
import LoginOrReg from './LoginOrReg.vue'

let a=createApp(LoginOrReg);
a.mount('#lk_app')
